export default __webpack_public_path__ + "static/cherries-4196f44a4e8daaba8b3082401a00b51b.svg";